import(/* webpackMode: "eager" */ "/app/src/app/[locale]/products/[[...segments]]/error.js")